export var RECOMMENDATION_BAR_TESTID = 'recommendation-bar-test-id';
export var RECOMMENDATION_BAR_MESSAGE = 'We recommend filling in the highlighted fields.';